import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'zipcode' })

export class ZipcodePipe implements PipeTransform {
    transform(zip: string) {
        // if (zip == null || zip === '') return '';
        // if (!(typeof String(zip))) return zip;
        // if (zip.length > 5) {
        //     var zip1 = zip.substr(0, 5);
        //     var zip2 = zip.substr(5);

        //     if (zip2 !== '0000' && zip2 !== '____') {
        //         return zip1 + '-' + zip2;
        //     } else {
        //         return zip1;
        //     }
        // } else return zip;

        if (!zip) return '';

        if (zip.length > 5) {
            let zip1 = zip.substr(0, 5);
            let zip2 = zip.substr(5);

            if (zip2 !== '0000') {
                return `${zip1}-${zip2}`;
            } else {
                return zip1;
            }
        } else return zip;
    };
}